var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    width: 120,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.232,213.541h119.659c25.493,0,46.232-20.739,46.232-46.232v-10.106l51.339,51.345 c1.561,1.561,3.65,2.388,5.771,2.388c1.05,0,2.116-0.201,3.122-0.62c3.051-1.262,5.037-4.237,5.037-7.539V72.011 c0-3.302-1.985-6.277-5.037-7.539c-3.04-1.262-6.554-0.566-8.893,1.768l-51.377,51.383c-0.397-25.15-20.951-45.498-46.194-45.498 H46.232C20.739,72.125,0,92.864,0,118.357v48.952C0,192.802,20.739,213.541,46.232,213.541z M261.075,91.711v91.371 l-45.683-45.688L261.075,91.711z M16.317,118.357c0-16.497,13.424-29.915,29.915-29.915h119.659 c16.491,0,29.915,13.418,29.915,29.915v18.466v1.148v29.338c0,16.497-13.424,29.915-29.915,29.915H46.232 c-16.491,0-29.915-13.418-29.915-29.915V118.357z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingsIcon);
export default __webpack_public_path__ + "static/media/recordings-icon.4b8d5879c1697136adb494b548061311.svg";
export { ForwardRef as ReactComponent };